import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/staff/bookings')({
  component: () => <Navigate to="/staff/orders" />,
});
